(function() {
	'use strict';

	var params = avm.require('avast.url.unserialize')(),
		detect = avastGlobals.detect,
		browser = detect.browser,
		page = document.querySelector('.dtyp-page[data-cmp-name="cmp-dtyp-page"]'),
		pageTexts = document.querySelectorAll('[data-dtyp-browser]'),
		note = page.querySelector('.dtyp-note'),
		progress = page.querySelector('.dtyp-progress'),
		link = document.querySelector('.bi-download-link'),
		businessLink = document.querySelector('.business-download-button');

	for (var i = 0; i < pageTexts.length; i++) {
		var text = pageTexts[i],
			textAttr = text.getAttribute('data-dtyp-browser');

		text.style.display = 'none';

		switch (true) {
			case browser.isChrome:
			case browser.isAvast:
				if (textAttr === 'chrome') {
					text.style.display = '';
				}
				break;
			case browser.isFirefox:
				if (textAttr === 'firefox') {
					text.style.display = '';
				}
				break;
			case browser.isEdgeChromium:
				if (textAttr === 'edge') {
					text.style.display = '';
				}
				break;
			default:
				if (textAttr === 'other') {
					text.style.display = '';
				}
				break;
		}
	}

	// Displays loading animation and redirect to the download file
	document.addEventListener('DOMContentLoaded', function() {
		if (typeof avastDownloadLink !== 'undefined' &&
			(avastDownloadLink.slice(-4) === '.exe' ||
				avastDownloadLink.slice(-4) === '.dmg' ||
				avastDownloadLink.slice(-4) === '.pkg' ||
				avastDownloadLink.slice(-4) === '.msi' ||
				avastDownloadLink.slice(-4) === '.u3p' ||
				avastDownloadLink.slice(-4) === '.zip' ||
				avastDownloadLink.match(/^https?:\/\/bits.ff.avast.com\//) ||
				avastDownloadLink.match(/^https?:\/\/bits.avcdn.net\//) ||
				avastDownloadLink.match(/^https:\/\/cdn-download\.avastbrowser\.com\//)
			)) {

			// If there is a file, hide note and show spinner:
			if (progress && note) {
				progress.classList.add('dtyp-progress-show');
				progress.classList.remove('d-none');
				note.classList.remove('dtyp-note-show');
				note.classList.add('d-none');

				setTimeout(function() {
					window.location = avastDownloadLink;
				}, 2000);

				setTimeout(function() {
					progress.classList.remove('dtyp-progress-show');
					setTimeout(function() {
						progress.classList.add('d-none');
						note.classList.remove('d-none');
						note.classList.add('dtyp-note-show');
					}, 330);
				}, 3000);
			}

		} else {
			progress.classList.remove('dtyp-progress-show');
			progress.classList.add('d-none');
			note.classList.add('dtyp-note-show');
			note.classList.remove('d-none');
		}
	});

	// Append data attribute with download ID to link
	if (params && params.product && link) {
		if ('dataset' in link) {
			link.dataset.biDownloadName = params.product;
		} else {
			link.setAttribute('data-bi-download-name', params.product);
		}
	}

	// Add tracking data to fallback link. TODO: add data attribut into jsontext on next loc export
	if (link) {
		link.setAttribute('data-position', 'dtp-download-link');
	}

	// Append data attribute with download ID to business link
	if (params && params.product && businessLink) {
		if ('dataset' in businessLink) {
			businessLink.dataset.biDownloadName = params.product;
		} else {
			businessLink.setAttribute('data-bi-download-name', params.product);
		}
	}

	// show arrow for old chrome download UI
	document.querySelector('.dtyp .dtyp-arrow-chrome').style.display = 'none';

})();
